import { MissionData } from '../blocks/mission'
import template from './templates/RJS08.rbxl'
import thumbnail1 from './thumbnails/RJS08/SpawnLocation.png'
import thumbnail2 from './thumbnails/RJS08/Block.png'
const mission: MissionData = {
  // Set the template and other metadata.
  // テンプレートとその他のメタデータを設定します。
  number: 2,
  stage: 0,
  thumbnail: '',
  title: '',
  template,
  chapters: [{}, {}, {}, {}, {}, {}],
  objects: [
    {
      name: '①スタートちてん',
      thumbnail: thumbnail1,
    },
    {
      name: '②ブロック',
      thumbnail: thumbnail2,
    },
  ],
}

export default mission
